import React from 'react';
import { Mui } from '@osu/react-ui';

/**
 * StudentListItem Component
 * Renders an individual student in the search results list
 */
function StudentListItem({
  student,
  selectedStudent,
  onStudentSelect,
  onKeyDown,
  isLast = false
}) {
  const isSelected = selectedStudent?.id === student.id;

  return (
    <Mui.ListItem
      role="option"
      tabIndex={0}
      onClick={() => onStudentSelect(student)}
      onKeyDown={(event) => onKeyDown(event, student)}
      sx={{
        cursor: 'pointer',
        borderBottom: !isLast ? '1px solid #f0f0f0' : 'none',
        '&:hover': {
          backgroundColor: isSelected ? '#d4edda' : '#f5f5f5'
        },
        '&:focus': {
          backgroundColor: '#e3f2fd',
          outline: '2px solid #1976d2',
          outlineOffset: '-2px'
        },
        backgroundColor: isSelected ? '#e8f5e8' : 'transparent',
        border: isSelected ? '2px solid #28a745' : 'none',
        borderRadius: isSelected ? 1 : 0
      }}
      aria-selected={isSelected}
    >
      <Mui.ListItemText
        primary={
          <Mui.Box>
            <Mui.Typography 
              variant="subtitle2" 
              component="div" 
              sx={{ display: 'flex', alignItems: 'center', gap: 1 }}
            >
              {student.name}
              {isSelected && (
                <Mui.Chip 
                  label="Selected" 
                  size="small" 
                  color="success" 
                  variant="filled"
                />
              )}
            </Mui.Typography>
            
            <Mui.Typography variant="body2" color="text.secondary">
              {student.email || 'No email available'} • ID: {student.id}
            </Mui.Typography>
          </Mui.Box>
        }
        secondary={
          <Mui.Box sx={{ mt: 0.5 }}>
            {student.programs.map((program) => (
              <Mui.Chip
                key={program}
                label={program}
                size="small"
                variant="outlined"
                sx={{ mr: 0.5, mb: 0.5 }}
              />
            ))}
          </Mui.Box>
        }
      />
    </Mui.ListItem>
  );
}

export default StudentListItem;